import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://1stnations-security-ontario.com";
export const SITE_NAME = "1st Nations Security";
export const PHONE = "+1 807-770-0243";
export const PHONE_TEL = "tel:+18077700243";
export const EMAIL = "admin@1stnation-security.com";

export const Seo = ({ title, description, path = "/", jsonLd, lang = "en-CA" }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
